/* eslint-disable
    import/order
*/
// Fix any style issues and re-enable lint.
import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';

import {SELECTORS_LINK, SimpleSpreadsheetEvalMixin} from 'notebook/simple-tables/SimpleSpreadsheetEvalMixin';
import {ASSAY_SCHEMA_SHAPE} from 'results/assay-schemas/AssaySchemaConstants';
import {ASSAY_RECORD_SHAPE} from 'results/assays/AssayRecordConstants';
import DataTableEditable from 'notebook/data-tables/DataTableEditable';
import * as DataTableConstants from 'notebook/data-tables/DataTableConstants';

import {fillEmptyDataTableWithResults} from './AssayGroupDataTables';
import {convertDataTableToTable, mergeTableUpdateIntoDataTable} from 'notebook/data-tables/DataTableUtil';

const AssayGroupResultsTable = createReactClass({
  mixins: [SimpleSpreadsheetEvalMixin],

  propTypes: {
    schema: ASSAY_SCHEMA_SHAPE.isRequired,
    results: PropTypes.arrayOf(ASSAY_RECORD_SHAPE.isRequired).isRequired,
    isOversized: PropTypes.bool.isRequired,
    forceRowCount: PropTypes.number,
    dataTable: DataTableConstants.dataTable.isRequired,
    downloadAsCSV: PropTypes.func,
    onDataTableUpdate: PropTypes.func.isRequired,
    editor: PropTypes.object.isRequired,
    editorProps: PropTypes.object.isRequired,
  },

  getDefaultProps() {
    return {isOversized: false};
  },

  _getFilledDataTable(props) {
    return fillEmptyDataTableWithResults(props.dataTable, props.results, props.schema);
  },

  /* Required by SpreadsheetEvalMixin */
  spreadsheetRoot(props) {
    return this._getFilledDataTable(props);
  },

  /* Required by SpreadsheetEvalMixin */
  shouldDisableFormulas() {
    return true;
  },

  /* Required by SimpleSpreadsheetEvalMixin */
  handleTableUpdate(index, {table, selection}) {
    // TODO(BNCH-2694): Call `this.props.editor.requestSelection(selection);` and thread metadataForRestore
    // to DataTablEditable for best editing experience.
    this._handleDataTableUpdate(index, {table});
  },

  /* Required by SimpleSpreadsheetEvalMixin */
  getTable(props) {
    return convertDataTableToTable(this._getFilledDataTable(props));
  },

  /* Required by SimpleSpreadsheetEvalMixin */
  getTableCid() {
    return this.props.dataTable.cid;
  },

  _handleDataTableUpdate(index, {table, item}) {
    const newDataTable = item || mergeTableUpdateIntoDataTable(this.props.dataTable, table);
    const newEmptyDataTable = {...newDataTable, rows: []};
    this.props.onDataTableUpdate(newEmptyDataTable);
  },

  render() {
    return (
      <DataTableEditable
        cid={this.getTableCid()}
        dataTable={this._getFilledDataTable(this.props)}
        downloadAsCSV={this.props.downloadAsCSV}
        editor={this.props.editor}
        editorProps={this.props.editorProps}
        editorOverrides={this.getTableEditableProps()}
        fileId={this.props.editorProps.fileId}
        registrationTables={[]}
        indentation={0}
        index={0}
        locked={this.props.editorProps.locked}
        updateHandler={this._handleDataTableUpdate}
        tableNamespace={this.state.tableNamespace}
        viewer={this.props.editorProps.viewer}
        computedTable={this.getComputedTable()}
        multiEditing={false}
        selectors={SELECTORS_LINK.value}
        selectorCounts={SELECTORS_LINK.selectorUsageCounts}
        showExcessLabels={this.state.showExcessLabels}
        metadataForRestore={undefined}
        cellColors={this.state.cellColors}
        forRun={true}
        isOversized={this.props.isOversized}
        forceRowCount={this.props.forceRowCount}
      />
    );
  },
});

export default AssayGroupResultsTable;
